
import { useSignal, useEffect } from './lib/reactivity';
import $ from 'jquery';
import { addToCart, addToRequestBasket, updateCartCount, updateRequestBasketCount } from './api/shop';

const initializeVinSearch = () => {

    const products = $('[data-vin-product-container]');
    products.each((_, product) => {
        let quantity_input = $(product).find('.quantity-input');
        let productId = $(product).data('product-id');
        let vin = $(product).data('vin');

        const subtractButton = $(product).find('.decrease-quantity');
        const addButton = $(product).find('.increase-quantity');
        const addToCartButton = $(product).find('.product-card-link-cart');
        const addToRequestButton = $(product).find('.product-card-link-request');
        addButton.off();
        subtractButton.off();



        if (!quantity_input) {
            return;
        }
        const [quantity, setQuantity] = useSignal(parseInt(quantity_input.val()) ?? 1);

        addButton.on('click', function() {
            setQuantity(quantity() + 1);
        });

        if (addToCartButton) {
            addToCartButton.off();
            addToCartButton.on('click', async function() {
                try {
                    await addToCart(productId, quantity(), vin);
                } catch (e) {
                    console.error(e)
                } finally {
                    await updateCartCount();
                }
            });
        }

        if (addToRequestButton) {
            addToRequestButton.off();
            addToRequestButton.on('click', async function() {
                try {
                    await addToRequestBasket(productId, quantity(), vin);
                } catch (e) {
                    console.error(e)
                } finally {
                    await updateRequestBasketCount();
                }
            });
        }


        subtractButton.on('click', function() {
            if (parseInt(quantity()) === 1) {
                return;
            }
            setQuantity(quantity() - 1);
        });

        useEffect(() => {
            quantity_input.val(quantity());
        });
    });
}

// The hierarchy of elements in vin page is as follows:
// .vin-search-group
//      .vin-search-subgroup
//          .vin-search-product
//              .vin-search-product (this is if a product has sub products or replacement parts)
// 
// Checkout Shop/Page/Search/vinsearch.html.twig for the structure 
//
// The logic is if there is a search term, we will hide all elements that don't match the search term 
// and show the ones that do. If there is no search term, we will show all elements.


/** 
 * This function will hide all sub groups elements that don't match the search term
 * and show the ones that do. It will return true if any of the sub groups match the search term 
 * Depending upon the return value, the group will be hidden or shown 
 * The logic for hiding/showing group is in the matchPatterns function 
 * @see matchPatterns
 */
const shouldShowGroup = (term, group) => {
    let subGroups = group.querySelectorAll('.vin-search-subgroup');
    let shouldShow = false;

    for (let subGroup of subGroups) {
        let subGroupList = subGroup.querySelector('ul');
        if (shouldShowSubGroup(term, subGroup)) {
            shouldShow = true;
            subGroup.classList.remove('hide');
            subGroupList.style.display = 'block';
        } else {
            subGroup.classList.add('hide');
            subGroupList.style.display = 'none';
        }
    }

    return shouldShow;
}

/**
 * This function will hide all products that don't match the search term 
 * and show the ones that do. It will return true if any of the products match the search term 
 * Depending upon the return value, the sub group will be hidden or shown 
 * The logic for hiding/showing sub group is in the shouldShowGroup function 
 * @see shouldShowGroup
 */
const shouldShowSubGroup = (term, subGroup) => {
    let products = subGroup.querySelectorAll('.vin-search-product');
    let shouldShow = false;

    for (let product of products) {
        if (shouldShowProduct(term, product)) {
            shouldShow = true;
            product.classList.remove('hide');

            // If the product has sub items, expand the sub items by clicking the trigger 
            const trigger = product.querySelector('.toggle-subitems');;
            if (trigger) {
                setTimeout(() => {
                    if (trigger.getAttribute('aria-expanded') === 'false') {
                        trigger.click();
                    }
                }, 100);
            }

        } else {
            product.classList.add('hide');
        }
    }

    return shouldShow;
}

/** 
 * This function will hide all products that don't match the search term 
 * and show the ones that do. It will return true if any of the products match the search term 
 * Depending upon the return value, the sub group will be hidden or shown 
 * The logic for hiding/showing sub group is in the shouldShowSubGroup function 
 * @see shouldShowSubGroup 
 */
const shouldShowProduct = (term, product) => {
    let title = product.dataset.productName;
    let articleId = product.dataset.articleId;

    let items = product.querySelectorAll('.vin-search-product');
    let shouldShow = false;

    if (title.toLowerCase().includes(term.toLowerCase()) || articleId.toLowerCase().includes(term.toLowerCase())) {
        shouldShow = true;
    } else {
        for (let item of items) {
            if (shouldShowProduct(term, item)) {
                shouldShow = true;
                item.classList.remove('hide');
            } else {
                item.classList.add('hide');
            }
        }
    }

    if (shouldShow) {
        product.classList.remove('hide');
    } else {
        product.classList.add('hide');
    }

    return shouldShow;
}

/** 
 * This function will hide all groups that don't match the search term 
 */
const matchPatterns = (term, groups) => {
    for (let group of groups) {
        let shouldShow = shouldShowGroup(term, group);
        if (shouldShow) {
            group.classList.remove('hide');
        } else {
            group.classList.add('hide');
        }
    }
}

const initializeVinFilters = () => {

    const groupEls = document.querySelectorAll('.vin-search-group');
    const subgroupEls = document.querySelectorAll('.vin-search-subgroup');
    const productEls = document.querySelectorAll('.vin-search-product');
    const input = document.getElementById('vinFilterInput');
    const form = document.getElementById('vinFilterForm');


    if (!input) {
        return;
    }

    // Term is the search term that the user enters in the search box
    const [term, setTerm] = useSignal('');

    if (form) {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            setTerm(input.value);
        });
    }


    input.addEventListener('input', function(e) {
        setTerm(e.target.value);
    });

    /** 
     * This function shows all the elements 
     */
    const activateAll = () => {
        for (let group of groupEls) {
            group.classList.remove('hide');
        }

        for (let subgroup of subgroupEls) {
            subgroup.classList.remove('hide');
        }

        for (let product of productEls) {
            product.classList.remove('hide');
        }
    }

    useEffect(() => {
        if (term().length === 0) {
            return activateAll();
        }
        return matchPatterns(term(), groupEls);
    });



}

$(document).ready(function() {
    initializeVinSearch();
    initializeVinFilters();
});
